import React from "react"
import { Helmet } from "react-helmet"

import { SITE_URL } from "../../utils/seoUrls"

const scripts = {
  googleAnalytics: {
    external: `https://www.googletagmanager.com/gtag/js?id=G-JGE3S1WZYL`,
    internal: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-JGE3S1WZYL');`,
  },
  fbPixel: `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1014978157264543');
    fbq('track', 'PageView');
  `,
  // hotjar: `
  //   (function(h,o,t,j,a,r){
  //       h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
  //       h._hjSettings={hjid:2945537,hjsv:6};
  //       a=o.getElementsByTagName('head')[0];
  //       r=o.createElement('script');r.async=1;
  //       r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
  //       a.appendChild(r);
  //   })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  // `,
}

// Only the production site sends data - not localhost, Netlify previews or
// other hosts serving a copy of the build.
const isProductionHost = () =>
  typeof window !== "undefined" &&
  window.location.hostname === new URL(SITE_URL).hostname

const Analytics = ({ statistics, marketing }) => {
  if (!isProductionHost()) return null

  return (
    <Helmet>
      {statistics && (
        <script async src={scripts.googleAnalytics.external}></script>
      )}
      {statistics && <script>{scripts.googleAnalytics.internal}</script>}
      {marketing && <script>{scripts.fbPixel}</script>}
      {/* {marketing && <script>{scripts.hotjar}</script>} */}
    </Helmet>
  )
}

export default Analytics
